import { useState } from 'react';
import './Tooltip.css';

export default function Tooltip({ children, tip, placement = 'bottom', dark }) {
  const [visible, setVisible] = useState(false);

  return (
    <span
      className="tooltip-wrap"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
    >
      <span className={`tt-host${dark ? ' tt-host--dark' : ''}`}>
        {children}
      </span>
      {visible && (
        <div
          className={`tooltip-arrow${placement === 'top' ? ' tooltip-arrow--top' : ''}${placement === 'right' ? ' tooltip-arrow--right' : ''}`}
          role="tooltip"
        >
          {tip}
        </div>
      )}
    </span>
  );
}
